/** Traductions newCashRegisterModal (FR / AR) */
export const newCashRegisterModalFr = {
  "veuillezSaisirMontant": "Veuillez saisir le montant",
  "veuillezSaisirMontantValide": "Veuillez saisir un montant valide",
  "veuillezSaisirRaisonDifference": "Veuillez saisir la raison de la différence",
  "caisseActuellementVerrouilleeVeuillezAttendre": "La caisse est actuellement verrouillée. Veuillez attendre que le travailleur actuel se déconnecte.",
  "caissePauseVeuillezAttendreReprise": "La caisse est en pause. Seul le caissier qui l'a mise en pause peut reprendre avec son code — aucun autre caissier ne peut se connecter.",
  "erreurProduiteVeuillezReessayer": "Une erreur s'est produite. Veuillez réessayer.",
  "modeLogin": "Connexion",
  "modeLogout": "Déconnexion",
  "modePause": "Pause",
  "deviation": "Écart",
  "attendu": "Attendu",
  "reel": "Réel",
  "recuCaisse": "Reçu de caisse",
  "colType": "Type",
  "colDate": "Date",
  "colWorker": "Employé",
  "cash": "Espèces",
  "electronic": "Électronique",
  "total": "Total",
  "note": "Note",
  "saisirMontantCaisse": "Saisir le montant en caisse",
  "confirmerMontantRestant": "Confirmer le montant restant",
  "pauseCaisse": "Pause de la caisse",
  "amount": "Montant",
  "confirmation": "Confirmation",
  "methodePaiement": "Méthode de paiement",
  "methodePaiementElectronique": "Méthode de paiement électronique",
  "montantActuelCaisse": "Montant actuel en caisse",
  "montantCaisse": "Montant en caisse",
  "saisirMontantActuel": "Saisir le montant actuel",
  "saisirMontantIci": "Saisir le montant ici",
  "devise": "Devise",
  "continueBtn": "Continuer",
  "cancel": "Annuler",
  "resumeDifference": "Résumé de la différence",
  "manque": "Manque",
  "surplus": "Surplus",
  "montantAttenduEspeces": "Montant attendu (espèces)",
  "montantReelEspeces": "Montant réel (espèces)",
  "montantElectroniqueAttendu": "Montant électronique attendu",
  "montantElectroniqueReel": "Montant électronique réel",
  "difference": "Différence",
  "montantElectroniqueAttenduFournisseur": "Montant électronique attendu (par fournisseur)",
  "totalElectroniqueAttendu": "Total électronique attendu",
  "ventesElectroniquesUniquement": "Ventes électroniques uniquement",
  "raisonDifference": "Raison de la différence",
  "saisissezRaisonDifference": "Saisissez la raison de la différence...",
  "back": "Retour",
  "confirmationOperation": "Confirmation de l'opération",
  "typeOperation": "Type d'opération",
  "montantEspeces": "Montant espèces",
  "montantElectronique": "Montant électronique",
  "processing": "Traitement...",
  "confirmationFinale": "Confirmation finale",
  "operationConfirmeeSucces": "Opération confirmée avec succès",
  "operationEteConfirmeeSuccesVous": "L'opération a été confirmée avec succès. Vous pouvez fermer la fenêtre.",
  "operationLogoutSuccesPrint": "Session clôturée. Vous pouvez imprimer le rapport, puis quitter tranquillement.",
  "imprimerRapport": "Imprimer le rapport",
  "close": "Fermer",
  "closeAndExit": "Fermer et quitter",
  "draftsLogoutBlocked": "Impossible de se déconnecter. Il y a {count} brouillon(s) non sauvegardé(s). Veuillez les supprimer ou les sauvegarder d'abord.",
  "workerLabel": "Caissier",
  "welcomeCashierTitle": "Bienvenue",
  "welcomeCashierMessage": "Bienvenue, {name} ! Bonne journée de caisse.",
  "welcomeCashierHint": "Saisissez l'ouverture, puis commencez vos ventes en confiance.",
  "farewellCashierTitle": "Bonne fin de service",
  "farewellCashierMessage": "Bonne fin de service, {name} ! Merci pour votre travail. À bientôt.",
  "pauseWelcomeTitle": "Pause de caisse",
  "pauseWelcomeMessage": "{name}, la caisse va être mise en pause. Seul vous pourrez reprendre avec votre code — aucun autre caissier ne pourra se connecter.",
  "pauseConfirmAction": "Mettre en pause",
  "resumeCashierMessage": "Reprise réussie, {name}. Bonne continuation !",
  "loginIntro": "Saisissez l'ouverture de caisse : espèces dans le tiroir et soldes électroniques (Bankily, Masrvi, etc.) avant de commencer le shift.",
  "loginAmountHint": "Montants physiques et électroniques présents au moment de la connexion.",
  "logoutIntro": "Comptez tout l'argent réel en caisse avant de vous déconnecter : espèces dans le tiroir et total des paiements électroniques.",
  "logoutCashHint": "Billets et pièces réellement présents dans le tiroir.",
  "logoutElectronicHint": "Total des encaissements électroniques (Bankily, Masrvi, etc.) de votre shift.",
  "deviationIntro": "Une différence a été détectée entre le montant attendu et le montant saisi. Vérifiez le résumé et indiquez la raison.",
  "showDetails": "Voir le détail du calcul",
  "hideDetails": "Masquer le détail",
  "confirmIntro": "Vérifiez les informations ci-dessous avant de valider définitivement.",
  "montantEspecesCompte": "Espèces comptées",
  "montantElectroniqueCompte": "Électronique compté",
  "calcDetailTitle": "Calcul détaillé (attendu vs réel)",
  "calcDetailHint": "Début + ventes + encaissements créances − paiements caisse − dépenses caisse = attendu. Le financement externe n'affecte pas l'écart caissier.",
  "columnLine": "Ligne",
  "outPayments": "Paiements (sorties caisse)",
  "outExpenses": "Dépenses (sorties caisse)",
  "externalFinancingRow": "Financement externe (hors caisse)",
  "managerOutflowsRow": "Sorties manager (hors écart caissier)",
  "salesRow": "Ventes",
  "debtCollectionsRow": "Encaissements créances",
  "openRow": "Début de session",
  "unspecified": "Non précisé",
  "providerColumn": "Fournisseur / méthode",
  "expectedColumn": "Attendu (système)",
  "countedColumn": "Compté (saisie)",
  "emptyAsZeroHint": "Champ vide = 0",
  "totalRow": "Total électronique",
  "salesAttenduHint": "Ventes session"
};

export const newCashRegisterModalAr = {
  "veuillezSaisirMontant": "يرجى إدخال المبلغ",
  "veuillezSaisirMontantValide": "يرجى إدخال مبلغ صحيح",
  "veuillezSaisirRaisonDifference": "يرجى إدخال سبب الاختلاف",
  "caisseActuellementVerrouilleeVeuillezAttendre": "الصندوق مقفل حالياً. يرجى انتظار تسجيل خروج العامل الحالي.",
  "caissePauseVeuillezAttendreReprise": "الصندوق متوقف مؤقتاً. فقط أمين الصندوق الذي أوقفه يمكنه الاستئناف برمزه — لا يمكن لأي كاشير آخر الدخول.",
  "erreurProduiteVeuillezReessayer": "حدث خطأ. يرجى المحاولة مرة أخرى.",
  "modeLogin": "دخول",
  "modeLogout": "خروج",
  "modePause": "إيقاف",
  "deviation": "الانحراف",
  "attendu": "المتوقع",
  "reel": "الفعلي",
  "recuCaisse": "إيصال الصندوق",
  "colType": "النوع",
  "colDate": "التاريخ",
  "colWorker": "العامل",
  "cash": "نقداً",
  "electronic": "إلكتروني",
  "total": "المجموع",
  "note": "ملاحظة",
  "saisirMontantCaisse": "إدخال المبلغ في الصندوق",
  "confirmerMontantRestant": "تأكيد المبلغ المتبقي",
  "pauseCaisse": "إيقاف مؤقت للصندوق",
  "amount": "المبلغ",
  "confirmation": "التأكيد",
  "methodePaiement": "طريقة الدفع",
  "methodePaiementElectronique": "طريقة الدفع الإلكتروني",
  "montantActuelCaisse": "المبلغ الموجود في الصندوق حالياً",
  "montantCaisse": "المبلغ في الصندوق",
  "saisirMontantActuel": "أدخل المبلغ الموجود حالياً",
  "saisirMontantIci": "أدخل المبلغ هنا",
  "devise": "العملة",
  "continueBtn": "متابعة",
  "cancel": "إلغاء",
  "resumeDifference": "ملخص الاختلاف",
  "manque": "نقص",
  "surplus": "زيادة",
  "montantAttenduEspeces": "المبلغ المتوقع (نقداً)",
  "montantReelEspeces": "المبلغ الفعلي (نقداً)",
  "montantElectroniqueAttendu": "المبلغ الإلكتروني المتوقع",
  "montantElectroniqueReel": "المبلغ الإلكتروني الفعلي",
  "difference": "الفرق",
  "montantElectroniqueAttenduFournisseur": "المبلغ الإلكتروني المتوقع (حسب المزود)",
  "totalElectroniqueAttendu": "الإجمالي الإلكتروني المتوقع",
  "ventesElectroniquesUniquement": "المبيعات الإلكترونية فقط",
  "raisonDifference": "سبب الاختلاف",
  "saisissezRaisonDifference": "أدخل سبب الاختلاف في المبلغ...",
  "back": "رجوع",
  "confirmationOperation": "تأكيد العملية",
  "typeOperation": "نوع العملية",
  "montantEspeces": "المبلغ النقدي",
  "montantElectronique": "المبلغ الإلكتروني",
  "processing": "جاري المعالجة...",
  "confirmationFinale": "تأكيد نهائي",
  "operationConfirmeeSucces": "تم التأكيد بنجاح",
  "operationEteConfirmeeSuccesVous": "تم تأكيد العملية بنجاح. يمكنك إغلاق النافذة.",
  "operationLogoutSuccesPrint": "تم إغلاق الوردية. يمكنك طباعة التقرير ثم المغادرة براحة.",
  "imprimerRapport": "طباعة التقرير",
  "close": "إغلاق",
  "closeAndExit": "إغلاق والخروج",
  "draftsLogoutBlocked": "لا يمكن تسجيل الخروج. يوجد {count} مسودة/مسودات غير محفوظة. يرجى حذفها أو حفظها أولاً.",
  "workerLabel": "أمين الصندوق",
  "welcomeCashierTitle": "مرحباً",
  "welcomeCashierMessage": "مرحباً، {name}! يوم طيب في الصندوق.",
  "welcomeCashierHint": "أدخل رصيد الافتتاح ثم ابدأ مبيعاتك بثقة.",
  "farewellCashierTitle": "نهاية طيبة",
  "farewellCashierMessage": "نهاية طيبة، {name}! شكراً على عملك. إلى اللقاء.",
  "pauseWelcomeTitle": "إيقاف مؤقت للصندوق",
  "pauseWelcomeMessage": "{name}، سيتم إيقاف الصندوق مؤقتاً. أنت وحدك من يمكنه الاستئناف برمزك — لا يمكن لأي كاشير آخر تسجيل الدخول.",
  "pauseConfirmAction": "إيقاف مؤقت",
  "resumeCashierMessage": "تمت الاستعادة، {name}. واصل بنجاح!",
  "loginIntro": "أدخل رصيد الافتتاح: النقد في الدرج والأرصدة الإلكترونية (Bankily، Masrvi، إلخ) قبل بدء الوردية.",
  "loginAmountHint": "المبالغ النقدية والإلكترونية الموجودة عند تسجيل الدخول.",
  "logoutIntro": "قبل تسجيل الخروج، عد كل الأموال الفعلية: النقد في الدرج وإجمالي المدفوعات الإلكترونية.",
  "logoutCashHint": "الأوراق والعملات المعدنية الموجودة فعلياً في الدرج.",
  "logoutElectronicHint": "إجمالي المدفوعات الإلكترونية (Bankily، Masrvi، إلخ) خلال ورديتك.",
  "deviationIntro": "تم اكتشاف فرق بين المبلغ المتوقع والمبلغ المُدخل. راجع الملخص واذكر السبب.",
  "showDetails": "عرض تفاصيل الحساب",
  "hideDetails": "إخفاء التفاصيل",
  "confirmIntro": "تحقق من المعلومات أدناه قبل التأكيد النهائي.",
  "montantEspecesCompte": "النقد المعدود",
  "montantElectroniqueCompte": "الإلكتروني المعدود",
  "calcDetailTitle": "حساب مفصل (متوقع مقابل فعلي)",
  "calcDetailHint": "البداية + المبيعات + تحصيل الديون − مدفوعات الصندوق − مصروفات الصندوق = المتوقع. التمويل الخارجي لا يؤثر على انحراف الصراف.",
  "columnLine": "البند",
  "outPayments": "مدفوعات (من الصندوق)",
  "outExpenses": "مصروفات (من الصندوق)",
  "externalFinancingRow": "تمويل خارجي (خارج الصندوق)",
  "managerOutflowsRow": "مصروفات المدير (خارج انحراف الصراف)",
  "salesRow": "المبيعات",
  "debtCollectionsRow": "تحصيل ديون العملاء",
  "openRow": "بداية الجلسة",
  "unspecified": "غير محدد",
  "providerColumn": "المزود / الطريقة",
  "expectedColumn": "المتوقع (النظام)",
  "countedColumn": "المعدود (إدخال)",
  "emptyAsZeroHint": "حقل فارغ = 0",
  "totalRow": "إجمالي الإلكتروني",
  "salesAttenduHint": "مبيعات الجلسة"
};
